import { AbstractControl, ValidatorFn } from '@angular/forms';
export function egnValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {

    let cValue = control.value;

    if ('' === cValue || !cValue) {
      return null;
    }

    let test = new EGN();

    return !test.isValid(cValue) ? { egn: { value: 'invalid' } } : null;
  };
}

export class EGN {

  monthBorn: number;
  dayBorn: number;
  regionNum: number;
  dateBorn: Date;
  egnNum: number;

  constructor() {
  }

  getNums(str, start, simbolNum) {

    return (str.substr(start, simbolNum) * 1);

  }


  getDateBorn() {
    let year_flag = 1900;

    if (this.monthBorn > 40) year_flag += 100;

    else if (this.monthBorn > 20) year_flag -= 100;

    this.monthBorn = (this.monthBorn % 20) - 1;

    return new Date(year_flag + this.getNums(this.egnNum, 0, 2), this.monthBorn, this.dayBorn);
  }

  isValid(egnNum: number) {


    this.egnNum = egnNum;

    this.monthBorn = this.getNums(this.egnNum, 2, 2);

    this.dayBorn = this.getNums(this.egnNum, 4, 2);

    this.regionNum = this.getNums(this.egnNum, 6, 3);

    this.dateBorn = this.getDateBorn();


    const REGEXP = /^\d{10}$/;


    if (!REGEXP.test(String(egnNum))) {
      return false;
    }


    if (new Date().getTime() < this.dateBorn.getTime() || this.dateBorn.getMonth() != this.monthBorn || this.dateBorn.getDate() != this.dayBorn) {

      return false;
    }


    let flagNum = new Array(2, 4, 8, 5, 10, 9, 7, 3, 6, 0);

    let lastNum = 0;
    let curNum = 0;

    for (let i = 0; i < flagNum.length; ++i) {

      curNum = this.getNums(this.egnNum, i, 1);

      lastNum += flagNum[i] * curNum;

    }

    if ((lastNum % 11) % 10 != curNum)

      return false;

    return true;

  }
}











